var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],style:(_vm.domStyle)},[_c('iframe',{ref:"iframe",staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.url,"scrolling":"auto","frameborder":"0"}}),_vm._v(" "),(_vm.isEnable)?_c('div',{style:(_vm.enableStyle)}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fe2a09e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/primitives/fvUrlEmbed/fvUrlEmbed.vue
// module id = null
// module chunks = 